import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Observable } from 'rxjs';
import { PermitSummaryService, PermitSummary } from 'src/app/services/permit-summary.service';
import { takeUntil } from 'rxjs/operators';
import * as XLSX from 'xlsx'; // SPREADSHEET RELATED
import { FormControl } from '@angular/forms';
import { PolicyQueryService } from 'src/app/services/policy-query.service';
import routejson from 'src/app/components/nav-bar-top/routejson.json';

type AOA = any[][]; // SPREADSHEET RELATED

@Component({
  selector: 'app-permits-table',
  templateUrl: './permits-table.component.html',
  styleUrls: ['./permits-table.component.scss']
})
export class PermitsTableComponent implements OnInit {

  summary: PermitSummary[];
  summary$: Observable<PermitSummary[]>; // FILTERING RELATED
  filter = new FormControl(''); // FILTERING RELATED

  x: AOA = [];

  routemap: any = routejson;
  applicationOpened: boolean = true;

  unsubscribe: Subject<any> = new Subject();

  constructor(private router: Router, 
              private permitSummaryService: PermitSummaryService,
              private policyQueryService: PolicyQueryService) {}

  ngOnInit() {
    // this.url = this.router.url;

    this.permitSummaryService.getSummary();

    this.permitSummaryService.currentSummary
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(summary => {
      if (summary) {
        this.summary = summary;
      }
    });

    this.x.push(Object.values(this.headings));

    for(let i=0; i<this.api.length; i++) {
      this.x.push(Object.values(this.api[i]));
    }

    // this.export(); // UNCOMMENT THIS TO TEST FILE EXPORT
    this.policyQueryService.currentPolicyQuery
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(policyQuery => {
      if (policyQuery) {
        this.applicationOpened = policyQuery[this.routemap['/new-permit']]['canAccess'];
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  // START WRITING TO SPREADSHEET

  data: AOA = [ [1, 2], [3, 4] ];
	wopts: XLSX.WritingOptions = { bookType: 'xlsx', type: 'array' };
	fileName: string = 'SheetJS.xlsx';

	onFileChange(evt: any) {
		/* wire up file reader */
		const target: DataTransfer = <DataTransfer>(evt.target);
		if (target.files.length !== 1) throw new Error('Cannot use multiple files');
		const reader: FileReader = new FileReader();
		reader.onload = (e: any) => {
			/* read workbook */
			const bstr: string = e.target.result;
			const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});

			/* grab first sheet */
			const wsname: string = wb.SheetNames[0];
			const ws: XLSX.WorkSheet = wb.Sheets[wsname];

			/* save data */
			this.data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1}));
		};
		reader.readAsBinaryString(target.files[0]);
	}

	export(): void {
		/* generate worksheet */
		const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(this.x);

		/* generate workbook and add the worksheet */
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

		/* save to file */
		XLSX.writeFile(wb, this.fileName);
	}

  // END WRITING TO SPREADSHEET

  // START DUMMY DATA

  headings: any = {
    prop1: "Title 1",
    prop2: "Title 2",
    prop3: "Title 3",
    prop4: "Title 4"
  }

  api: any = [
    {
      prop1: "Value A1",
      prop2: "Value A2",
      prop3: "Value A3",
      prop4: "Value A4"
    },{
      prop1: "Value B1",
      prop2: "Value B2",
      prop3: "Value B3",
      prop4: "Value B4"
    },{
      prop1: "Value C1",
      prop2: "Value C2",
      prop3: "Value C3",
      prop4: "Value C4"
    },{
      prop1: "Value D1",
      prop2: "Value D2",
      prop3: "Value D3",
      prop4: "Value D4"
    }
  ]

  // END DUMMY DATA

}
